import React from "react";

export default function Certifications({ data }) {
  const returnImg = (item) => {
    if (item) {
      if (item?.includes("CCPA") || item?.includes("ISO")) {
        return "/images/ext/companyinfo/store.svg";
      } else if (item?.includes("GDPR")) {
        return "/images/ext/companyinfo/hand.svg";
      } else if (item?.includes("SOC")) {
        return "/images/ext/companyinfo/cart.svg";
      } else {
        return "/images/ext/companyinfo/store.svg";
      }
    } else {
      return "/images/ext/companyinfo/store.svg";
    }
  };
  return (
    <>
      {data && data.length > 0 && (
        <div className="border rounded-[14px] overflow-hidden border-border  bg-background relative mt-4 p-4 pb-2">
          <div className="mb-4">
            <span className="text-[16px] text-text-700 mr-3 font-bold">Security and Certifications</span>
            <span className="block text-sm">
              Discover engagement and business collaboration opportunities
            </span>
          </div>

          <div className="mt-3 -mr-3">
            {data.map((item) => (
              <>
                <div className="border rounded-[14px] overflow-hidden border-input  bg-gray-100 relative p-4 w-[48.5%] inline-block mr-[1.5%] mb-[1%]">
                  <div className="flex items-center">
                    <img src={returnImg(item)} className="mr-3 no-invert" />
                    <div className="inline-flex">
                      <span className="text-[16px] text-gray-900 block">{item}</span>
                    </div>
                  </div>
                </div>
              </>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
